import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import validateRegisterNumber from './validate';
import FormGroup from '../../../common-components/FormGroup';
import { clearRegistrationBackendError, fetchRealtimeValidations } from '../../data/actions';

/**
 * Register Number field wrapper. It accepts the following handlers:
 * - handleChange: for updating the register number value
 * - handleErrorChange: for setting or clearing field-specific error messages
 *
 * It is responsible for:
 * - Triggering backend validation for the register number (TIN)
 * - Displaying validation error if the TIN is not found or is duplicate
 * - Clearing validation error on focus
 * - Updating the input value on change
 */
const RegisterNumberField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const validationApiRateLimited = useSelector(state => state.register.validationApiRateLimited);

  const {
    handleErrorChange,
  } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validateRegisterNumber(value, formatMessage);

    if (fieldError) {
      handleErrorChange('register_number', fieldError);
    } else if (!validationApiRateLimited) {
      dispatch(fetchRealtimeValidations({ register_number: value }));
    }
  };

  const handleOnFocus = () => {
    handleErrorChange('register_number', '');
    dispatch(clearRegistrationBackendError('register_number'));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

RegisterNumberField.defaultProps = {
  errorMessage: '',
};

RegisterNumberField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default RegisterNumberField;
